export default __webpack_public_path__ + "static/media/mamaTierra.5427705d.png";